import { render, staticRenderFns } from "./ebookModal.vue?vue&type=template&id=6c12e464&scoped=true&"
import script from "./ebookModal.vue?vue&type=script&lang=js&"
export * from "./ebookModal.vue?vue&type=script&lang=js&"
import style0 from "./ebookModal.vue?vue&type=style&index=0&id=6c12e464&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12e464",
  null
  
)

export default component.exports